'use strict';

angular.module('msGoals').filter('isHabitActive', [function () {
  return function (habitArray) {
    return _.filter(habitArray, function (e) {
      return _.isUndefined(e.widgets[0].properties.completed) || e.widgets[0].properties.completed === 'false';
    });
  };
}]);